import { IOpportunityExpertRejectionRecord } from '../models/experts.models';

export const getExpertRejectionMock = (
  rejectedOn: Date | string | number
): IOpportunityExpertRejectionRecord => ({
  code: 'unknown',
  source: 'unknown',
  rejectedOn: new Date(rejectedOn).getTime(),
});
